import { Worksheet } from "exceljs";
import { GroupableDataGridColDef } from "./groupableDataGrid";

export interface ExcelFormatterResult {
    value: string | number;
    type: "string" | "number";
    decimals?: number;
}

export interface ExceljsPostProcessParams {
    worksheet: Worksheet;
}

export function exceljsPostProcess(
    { worksheet }: ExceljsPostProcessParams,
    gridDef: GroupableDataGridColDef<any>[]
) {
    worksheet.columns.map((c) => {
        const excelFormatter = gridDef.find(
            (g) => g.field === c.key
        )?.excelFormatter;

        if (!!excelFormatter) {
            c.eachCell((cell, rowNumber) => {
                // Skip header cell
                if (rowNumber > 1) {
                    const { value, type, decimals } = excelFormatter(
                        cell.value
                    );

                    cell.value = value;

                    if (type === "number") {
                        let numFmt = "0";

                        if (decimals) {
                            numFmt += ".";

                            // Add given number of decimals to the number format.
                            for (let i = 0; i < decimals; i++) {
                                numFmt += "0";
                            }
                        }

                        cell.numFmt = numFmt;
                    }
                }
            });
        }
    });
}
